
// @ts-ignore
import { grpc, common } from '@aitmed/aitmed-grpc-sdk-test'
import crypto from '../crypto'
import edgeServices from '../edges'
import utils from '../../utils'
import Response from '../../common/Response'

import {
    RequestVerificationCodeArgs,
    CreateUserArgs,
    LoginArgs,
    LoginNewDeviceArgs,
    LoginArgsExistingDevice
} from './types'


export default class Account {
    async requestVerificationCode({ phone_number }: RequestVerificationCodeArgs) {
        const name = { phone_number }
        const nameJSONString = JSON.stringify(name)
        try {
            const deat = await edgeServices.createEdge({
                etype: common.codes.EtypeCode.sendVerificationCode,
                apiVersion: 'v1beta1',
                name: nameJSONString,
            })
            return { status: deat.status }
        } catch (error) {
            throw error
        }
    }

    async createUser({
        password,
        phone_number,
        verification_code,
    }: CreateUserArgs) {
        //generate assymetric keyPair
        const { publicKey, secretKey } = crypto.generateAKey()
        //symmetrically encrypt secretKey with password
        const encryptedSecretKey = utils.encryptSecretKeyWithPassword({ password, secretKey })
        const name = {
            pk: publicKey,
            esk: encryptedSecretKey,
            phone_number,
            verification_code,
        }
        //normalize arguments for createUser eType
        const userArgsInstance = new common.types.CreateUserArgs()
        Object.assign(userArgsInstance, name)

        try {
            const deat = await edgeServices.createEdge({
                etype: common.codes.EtypeCode.createUser,
                apiVersion: 'v1beta1',
                name: userArgsInstance.toJSONString(),
                callBack: utils.generalCallback
            })
            //store credentials in local storage
            if (deat.status === 0) {
                utils.storeCredentialsInLocalStorage({ publicKey, secretKey, jwt: deat.token, user: deat.user_id })
            }
            // return { status: deat.status }
            return new Response({ code: deat.status, message: 'Success userdd', data: [3, 4, 5, 6] })

        } catch (error) {
            throw error
        }
    }

    async login({ phone_number, verification_code }: LoginArgs) {
        debugger
        //check if secretKey is in localStorage
        const secretKeyBase64String = localStorage.getItem('secretKey')
        if (secretKeyBase64String) {
            debugger
            //user info is in localStorage
            //TODO may have to check token expiration here
            let user_id
            user_id = localStorage.getItem('user')
            const secretKeyUint8Array = crypto.base64ToUint8Array(secretKeyBase64String)
            const phoneNumberTo32BitArray = utils.normalizeStringTo32BitArray(phone_number)
            const encryptedPhoneNumber = crypto.sKeyEncrypt(secretKeyUint8Array, phoneNumberTo32BitArray)
            const encryptedPhoneNumberToBase64 = crypto.uint8ArrayToBase64(encryptedPhoneNumber)

            return this.loginExistingDevice({ user_id, encrypted_phone_number: encryptedPhoneNumberToBase64 })

        } else if (phone_number && verification_code) {
            debugger
            //user is logging in from new device 
            return this.loginNewDevice({
                phone_number,
                verification_code
            })
        } else {
            //TODO provide a more descriptive error for required credentials
            throw new Error('Please provide user phone_number, and verification_code')
        }
    }

    async loginExistingDevice({ user_id, encrypted_phone_number }: LoginArgsExistingDevice) {
        const name = {
            encrypted_phone_number,
            user_id
        }
        const nameJSONString = JSON.stringify(name)
        try {
            const deat = await edgeServices.createEdge({ etype: common.codes.EtypeCode.loginUser, apiVersion: 'v1beta1', name: nameJSONString, callBack: utils.generalCallback })
            //replace jwt token
            localStorage.setItem('jwt', deat.token)
            return { status: deat.status }
        } catch (error) {
            throw error
        }
    }


    //if the deat field does not include a  publicKey and secretKey pair then the 
    //the user has not been registered and needs to be directed to the signUp page
    //TODO add error handling for unregistered user
    async loginNewDevice({ phone_number, verification_code }: LoginNewDeviceArgs) {
        const name = {
            phone_number, verification_code
        }
        const nameJSONString = JSON.stringify(name)
        try {
            const deat = await edgeServices.createEdge({ etype: common.codes.EtypeCode.loginNewDevice, apiVersion: 'v1beta1', name: nameJSONString, callBack: utils.generalCallback })
            debugger
            if (deat.pk && deat.sk) {
                //we know the user is registered since they have a publicKey and secretKey pair 
                utils.storeCredentialsInLocalStorage({ secretKey: deat.sk, publicKey: deat.pk, jwt: deat.token, user: deat.user_id })
                return new Response({ code: deat.status, message: 'Success login' })
            } else {
                throw new Error('User is not found in our system. Please redirect user to signup.')
            }
        } catch (error) {
            throw error
        }
    }

    //  logout(args: LogoutArgs) {
    //     console.log(args)
    //     return 'edge'
    // }

    //  deactivateUser(args: deactivateUserArgs) {
    //     console.log(args)
    //     return 'edge'
    // }

}
